module.exports = __webpack_public_path__ + "static/media/pmfs-tag.e656ab06.svg";